module.exports = __webpack_public_path__ + "static/favicon-81b4afea443ae6da40d4a1ff679eaea8.ico";